export const layouts = ["folio", "signal", "gallery", "atlas", "tide"] as const;
export type Theme = (typeof layouts)[number];
export const brands = {
  contrasted: {
    name: "contrasted",
    note: "Adventurous public radio from around the world",
  },
} as const;
export type Appearance = {
  brand: keyof typeof brands;
  font: "editorial" | "sans" | "humanist" | "serif" | "mono";
  textSize: 18 | 20 | 22 | 24 | 28;
  palette: "theme" | "linen" | "ocean" | "plum" | "night";
  motion: "system" | "reduced";
  contrast: boolean;
  spacing: boolean;
  underline: boolean;
  followPlayback: boolean;
};
export const defaultAppearance: Appearance = {
  brand: "contrasted",
  font: "editorial",
  textSize: 18,
  palette: "theme",
  motion: "system",
  contrast: false,
  spacing: false,
  underline: false,
  followPlayback: true,
};
export function readAppearance(value: unknown): Appearance {
  const result = { ...defaultAppearance };
  if (!value || typeof value !== "object") return result;
  const v = value as Record<string, unknown>;
  const choices: Record<string, readonly unknown[]> = {
    brand: Object.keys(brands),
    font: ["editorial", "sans", "humanist", "serif", "mono"],
    textSize: [18, 20, 22, 24, 28],
    palette: ["theme", "linen", "ocean", "plum", "night"],
    motion: ["system", "reduced"],
  };
  for (const key of Object.keys(result) as (keyof Appearance)[]) {
    if (
      choices[key] ? choices[key].includes(v[key]) : typeof v[key] === "boolean"
    )
      Object.assign(result, { [key]: v[key] });
  }
  return result;
}
